// addMessageIdToShortWatchedList.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import { SHORTS_NEED_AUTH_THRESHOLD } from '../RemoteConfigKeys.js';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import login from '../action/login.js';
import getOperationData from '../selector/getOperationData.js';

const watchedList = new Set();

/**
 * Add short to watched list
 * @kind action
 * @param {string} {messageId} - action param.
 * @return {Promise} Action promise.
 */
const addMessageIdToShortWatchedList =
  ({ messageId }) =>
  async (dispatch, getState) => {
    if (!messageId) return dispatch({ type: '' });

    const threshold = getRemoteConfigData(
      getState(),
      SHORTS_NEED_AUTH_THRESHOLD
    );
    const isAuthed = !!getMeData(getState(), 'id');
    const hasDisplayedNeedAuth = getOperationData(
      getState(),
      ['shorts'],
      'hasRemindneedAuth'
    );
    if (threshold && !isAuthed && !hasDisplayedNeedAuth) {
      watchedList.add(messageId);

      const shouldLogin =
        watchedList.size - 1 > 0 && (watchedList.size - 1) % threshold === 0;
      if (shouldLogin) {
        dispatch({
          type: MERGE_OPERATION_DATA,
          payload: {
            selectPath: ['shorts'],
            data: {
              hasRemindneedAuth: true,
            },
          },
        });
        return dispatch(login());
      }
    }
  };

export default addMessageIdToShortWatchedList;
